// @core/api/endpoints/task/remove_task_watcher.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/task';

/**
 * Remove task watcher
 * Removes an actor from the task's watcher list. They will no longer receive notifications for this task.
 */
export async function RemoveTaskWatcher(
  task_id: string,
  watcher_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/watchers/:watcher_id`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  requestPath = requestPath.replace(':watcher_id', encodeURIComponent(watcher_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
